import { CustomInputCurrency as InputCurrency } from '../../../../components/CustomInputCurrency';
import { CustomInputNumber as InputNumber } from '../../../../components/CustomInputNumber';
import { CustomSelectPicker as SelectPicker } from '../../../../components/CustomSelectPicker';
import { Label } from '../../../../components/Label';
import { rewardTypesKeys, selectRewardTypeData } from '../../constants';

export function RewardSection({ form, onChange }) {
  const isFixed = form.rewardType === rewardTypesKeys.desconto_fixo;
  const isPercentage = form.rewardType === rewardTypesKeys.desconto_percentual;
  const isDelivery = form.rewardType === rewardTypesKeys.frete_gratis;
  const isCashback = form.rewardType === rewardTypesKeys.cashback;

  return (
    <>
      <div>
        <Label>O que o cliente ganha ao atingir a meta</Label>
        <SelectPicker
          style={{ width: '100%' }}
          data={selectRewardTypeData}
          value={form.rewardType}
          placeholder="Selecione a recompensa"
          searchable={false}
          onSelect={onChange('rewardType')}
        />
      </div>

      {isDelivery && (
        <div style={{ fontSize: 13, color: '#2563eb' }}>
          🚚 Frete grátis, nenhum valor adicional necessário
        </div>
      )}

      {(isFixed || isCashback) && (
        <InputCurrency
          placeholder="R$ 0,00"
          label={isCashback ? 'Valor do cashback' : 'Valor do desconto (R$)'}
          value={form.rewardValue}
          onChange={onChange('rewardValue')}
        />
      )}

      {isPercentage && (
        <InputNumber
          placeholder="Ex: 15"
          label="Percentual de desconto (%)"
          value={form.rewardPercentage}
          onChange={onChange('rewardPercentage')}
        />
      )}
    </>
  );
}
